import React from 'react';
import { SvgIcon } from '@mui/material';

const styles = {
  viewBoxStyle: '0 0 24 24',
  iconStyle: {
    width: 24,
    height: 24,
  },
};

class DataSetIcon extends React.Component {
  render() {
    const { htmlColor = '#5f606d' } = this.props;

    return (
      <SvgIcon viewBox={styles.viewBoxStyle} style={styles.iconStyle} {...this.props}>
        <g clipPath="url(#clip0_1566_4840)">
          <path
            d="M7 0H4C1.79086 0 0 1.79086 0 4V7C0 9.20914 1.79086 11 4 11H7C9.20914 11 11 9.20914 11 7V4C11 1.79086 9.20914 0 7 0Z"
            fill={htmlColor}
          />
          <path
            d="M20 0H17C14.7909 0 13 1.79086 13 4V7C13 9.20915 14.7909 11 17 11H20C22.2091 11 24 9.20915 24 7V4C24 1.79086 22.2091 0 20 0Z"
            fill={htmlColor}
          />
          <path
            d="M7 13H4C1.79086 13 0 14.7909 0 17V20C0 22.2092 1.79086 24 4 24H7C9.20914 24 11 22.2092 11 20V17C11 14.7909 9.20914 13 7 13Z"
            fill={htmlColor}
          />
          <path
            d="M20 13H17C14.7909 13 13 14.7909 13 17V20C13 22.2092 14.7909 24 17 24H20C22.2091 24 24 22.2092 24 20V17C24 14.7909 22.2091 13 20 13Z"
            fill={htmlColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_1566_4840">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  }
}

export default DataSetIcon;
